<template>
  <label
    class="amw-radio-wrap radio-label focus disBl"
    :class="{ NCAcmi_radio_off: disabled }"
    :style="{ cursor: disabled ? 'default' : 'pointer' }"
  >
    <input
      type="radio"
      class="amw-global-radio"
      :name="`activity-radio-${unique}`"
      :value="example.se_code"
      @change="selectActivity"
      :checked="checked"
      :disabled="disabled"
    />
    <span class="amw-radio-overlay"></span>
    <span class="amw-label-radio-text">
      {{ displayText }} <em v-if="example.remain_num !== null">(잔여 {{ example.remain_num }})</em>
    </span>
  </label>
</template>

<script>
import { SURVEY_SAPPORO, GET_DATA_IDX_BY_TYPE, SELECT_CHOICE_DATA } from '@/store/actions/survey'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SurveyActivityExample',
  props: {
    examples: {
      type: Array,
      required: true
    },
    example: {
      type: Object,
      required: true
    },
    attendant: {
      type: Object,
      required: true
    },
    unique: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isMassageActivity: ['E023', 'E034', 'E045'].includes(this.example.se_code),
      birthYear: this.attendant.questions["Q202"].raw_data,
      // 2000년대 이후 출생인지 구분하기 위해 뒷자리 첫번째 자리 추출
      reference: this.attendant.questions["Q203"].raw_data ? this.attendant.questions["Q203"].raw_data.substring(0, 1) : 1,
    }
  },
  computed: {
    ...mapState(SURVEY_SAPPORO, {
      originals: state => state.originals,
    }),
    ...mapGetters(SURVEY_SAPPORO, {
      getDataIdx: GET_DATA_IDX_BY_TYPE,
    }),
    // 일반 액티비티 key값
    normalExampleKeys() {
      return this.examples.map(example => example.se_code);
    },
    responseIdx() {
      return this.getDataIdx(this.attendant.type, this.attendant.type_seq);
    },
    // 15세 미만 불가능(마사지 액티비티만)
    unavailable() {
      if(!this.isMassageActivity) return false;

      const age = this.getAge(this.birthYear, this.reference);
      return age < 15;
    },
    choices() {
      return this.attendant.questions[this.example.sq_code];
    },
    choice() {
      return this.choices.find(choice => !choice.se_code || this.normalExampleKeys.includes(choice.se_code));
    },
    displayText() {
      if (['MALE', 'FEMALE'].includes(this.example.parent)) {         
        return `${this.example.display_text} (${this.example.parent === 'MALE' ? '남성':'여성'})` ;
      }else {
        return this.example.display_text; 
      }
    },
    checked() {
      return this.choice.se_code === this.example.se_code;
    },
    disabled() {
      return this.unavailable || (this.example.se_code !== this.prevSelectedExample && this.example.remain_num === 0);
    },
    // 이전에 선택했던 액티비티
    prevSelectedExample() {
      if(this.originals) {
        const originalResponse = this.originals[this.responseIdx];
        if(originalResponse && originalResponse.questions && originalResponse.questions[this.example.sq_code]) {
          const prevExample = originalResponse.questions[this.example.sq_code].find(choice => this.normalExampleKeys.includes(choice.se_code));
          if(prevExample) {
            return prevExample.se_code;
          }
        }
      }
      return null;
    },
  },
  methods: {
    getAge(birthYear, reference) {
      let firstDigit;
      switch (reference) {
        case '1':
        case '2':
        case '5':
        case '6':
          firstDigit = '19';
          break;
        case '3':
        case '4':
        case '7':
        case '8':
          firstDigit = '20';
          break;
        case '9':
        case '0':
          firstDigit = '18';
          break;
        default:
          break;
      }

      const year = Number(`${firstDigit}${birthYear.substring(0, 2)}`);
      const month = Number(birthYear.substring(2, 4)) - 1;
      const date = Number(birthYear.substring(4, 6));
      // console.log(year, month, date);
      const today = new Date();
      const birthDate = new Date(year, month, date);
      // console.log(birthDate);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
      }
      return age;
    },
    selectActivity() {
      this.$store.dispatch(`${SURVEY_SAPPORO}/${SELECT_CHOICE_DATA}`, {
        idx: this.responseIdx,
        sq_code: this.example.sq_code,
        se_code: this.example.se_code,
        se_data: null,
        remarks: this.example.parent
      });
    },
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/surveys/sapporo/components/SurveyActivityExample.vue